export default __webpack_public_path__ + "static/media/chevron-up.6f7388f3.svg";